<template>
  <label for="password" class="ic1-text-label-1" v-html="label"></label>
  <div class="container">
    <input
      id="password"
      name="password"
      type="password"
      ref="input"
      :value="modelValue"
      :required="required"
      @input="checkUserInput"
      :class="inputClasses"
      @focus="handleOnFocus"
      autocomplete="current-password"
    />
    <div class="show-hide-box">
      <input
        id="showHide"
        type="checkbox"
        class="showpasswordcheckbox"
        @change="togglePasswordVisibility"
      />
      <a href="#">
        <label class="showHideLabel" for="showHide" style="width: 22px;">
          <img :src="visibilityIcons.off" ref="eyeIcon" :alt="icon_alt"/>
        </label>
      </a>
    </div>
  </div>
</template>

<script>
import visibilityIcon from "./visibilityIconBase64";

export default {
  name: "PasswordField",
  inheritAttrs: false,
  props: {
    modelValue: String,
    required: Boolean,
    icon_alt: String,
    label: String,
    inputClasses: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      visibilityIcons: visibilityIcon
    };
  },
  methods: {
    checkUserInput($event) {
      this.$emit("update:modelValue", $event.target.value);
    },
    getValue() {
      return this.$refs.input.value;
    },
    togglePasswordVisibility() {
      if (this.$refs.input.type === "password") {
        this.$refs.input.type = "text";
        this.$refs.eyeIcon.src = this.visibilityIcons.on;
      } else {
        this.$refs.input.type = "password";
        this.$refs.eyeIcon.src = this.visibilityIcons.off;
      }
    },
    handleOnFocus() {
      this.$emit("on-focus");
    }
  },
  beforeMount() {
    this.src = this.visibilityIcons.off;
  }
};
</script>
<style lang="css" scoped>
.container {
  display: flex;
  align-items: center;
  width: inherit;
}

#password {
  padding-right: calc(1.375rem + 10px);
}

.show-hide-box {
  display: inline-block;
  margin-left: calc(-1.375rem - 10px);
}

.show-hide-box > input {
  display: none;
}

.show-hide-box > label {
  cursor: pointer;
  display: flex;
}

.show-hide-box > label > img {
  width: 1.375rem;
  height: 1.188rem;
}
</style>
